/**
 * Utilitário para mapear nomes de telas para ícones do Material-UI
 */
import * as React from 'react'
import DashboardIcon from '@mui/icons-material/Dashboard'
import GroupIcon from '@mui/icons-material/Group'
import BusinessIcon from '@mui/icons-material/Business'
import PeopleIcon from '@mui/icons-material/People'
import HistoryIcon from '@mui/icons-material/History'
import ListAltIcon from '@mui/icons-material/ListAlt'
import SettingsIcon from '@mui/icons-material/Settings'
import MenuBookIcon from '@mui/icons-material/MenuBook'
import AppsIcon from '@mui/icons-material/Apps'
import CategoryIcon from '@mui/icons-material/Category'
import BuildIcon from '@mui/icons-material/Build'
import BackupIcon from '@mui/icons-material/Backup'
import FolderIcon from '@mui/icons-material/Folder'
import DescriptionIcon from '@mui/icons-material/Description'
import ViewListIcon from '@mui/icons-material/ViewList'
import HomeIcon from '@mui/icons-material/Home'
import InventoryIcon from '@mui/icons-material/Inventory'
import AssessmentIcon from '@mui/icons-material/Assessment'
import PaymentIcon from '@mui/icons-material/Payment'
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart'
import StoreIcon from '@mui/icons-material/Store'
import AccountCircleIcon from '@mui/icons-material/AccountCircle'
import SecurityIcon from '@mui/icons-material/Security'

// Mapeamento de palavras-chave para ícones
const iconMap: Record<string, React.ComponentType> = {
  dashboard: DashboardIcon,
  home: HomeIcon,
  inicio: HomeIcon,
  grupos: GroupIcon,
  group: GroupIcon,
  empresas: BusinessIcon,
  empresa: BusinessIcon,
  company: BusinessIcon,
  usuarios: PeopleIcon,
  usuario: PeopleIcon,
  user: PeopleIcon,
  users: PeopleIcon,
  sessao: HistoryIcon,
  sessoes: HistoryIcon,
  session: HistoryIcon,
  sessions: HistoryIcon,
  log: ListAltIcon,
  logs: ListAltIcon,
  backup: BackupIcon,
  backups: BackupIcon,
  area: CategoryIcon,
  areas: CategoryIcon,
  funcional: CategoryIcon,
  config: SettingsIcon,
  settings: SettingsIcon,
  configuração: SettingsIcon,
  dicionario: MenuBookIcon,
  dicionário: MenuBookIcon,
  sistema: AppsIcon,
  system: AppsIcon,
  galatea: AppsIcon,
  manutencao: BuildIcon,
  manutenção: BuildIcon,
  maintenance: BuildIcon,
  pasta: FolderIcon,
  folder: FolderIcon,
  documento: DescriptionIcon,
  document: DescriptionIcon,
  lista: ViewListIcon,
  list: ViewListIcon,
  estoque: InventoryIcon,
  inventory: InventoryIcon,
  relatorio: AssessmentIcon,
  relatório: AssessmentIcon,
  report: AssessmentIcon,
  pagamento: PaymentIcon,
  payment: PaymentIcon,
  venda: ShoppingCartIcon,
  vendas: ShoppingCartIcon,
  sale: ShoppingCartIcon,
  sales: ShoppingCartIcon,
  loja: StoreIcon,
  store: StoreIcon,
  perfil: AccountCircleIcon,
  profile: AccountCircleIcon,
  seguranca: SecurityIcon,
  segurança: SecurityIcon,
  security: SecurityIcon,
}

/**
 * Retorna um ícone baseado no nome da tela
 * Faz busca case-insensitive e por palavras-chave
 */
export const getIconForTela = (nome: string): React.ReactNode => {
  const nomeLower = nome.toLowerCase().trim()
  
  // Tentar encontrar correspondência exata primeiro
  if (iconMap[nomeLower]) {
    const IconComponent = iconMap[nomeLower]
    return React.createElement(IconComponent)
  }
  
  // Tentar encontrar por palavras-chave
  for (const [keyword, IconComponent] of Object.entries(iconMap)) {
    if (nomeLower.includes(keyword)) {
      return React.createElement(IconComponent)
    }
  }
  
  // Ícone padrão se não encontrar correspondência
  return React.createElement(DescriptionIcon)
}

